import baseEditForm from "formiojs/components/table/Table.form";
import StyleComponentForm from "./StyleComponent.form";

export default (...extend) => {
  return baseEditForm(
    [
      {
        label: "Component",
        key: "component-styles",
        weight: 80,
        components: new StyleComponentForm("Component").jsonElement()
      },
      {
        label: "Name",
        key: "label-styles",
        weight: 90,
        components: new StyleComponentForm("Name").jsonElement()
      }
    ],
    ...extend
  );
};
